export default __webpack_public_path__ + "static/media/celebrate-16px.09057dba.svg";